<template>
    <div v-if="fetcher.initialized">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body" style="min-height:100vh">

            <div class="container-fluid">
            
                <h1 class="mb-10">Värva en vän – få en gratis behandling!</h1>
                
                    <div class="row mb-12">
                        <div class="col-7">
                            <div class="round-image">
                                <img src="/images/card/illustration-kram.png">
                            </div>
                        </div>

                        <div class="col-17">
                            <h2>1. Dela länken</h2>
                            <p class="mb-3">Skicka din unika länk till en vän.</p>
                            <button class="btn btn-primary" @click="showShare()">Dela länken</button>
                        </div>

                    </div>

                    <div class="row mb-12">
                        <div class="col-7">
                            <div class="round-image">
                                <img src="/images/card/illustration-kop.png">
                            </div>
                        </div>

                        <div class="col-17">
                            <h2>2. Din vän gör ett köp</h2>
                            <p>Din vän fyller i sitt telefonnummer och köper ett klippkort på massage med samma nummer.</p>
                        </div>
                    </div>

                    <div class="row mb-12">
                        <div class="col-7">
                            <div class="round-image">
                                <img src="/images/card/illustration-massage.png">
                            </div>
                        </div>

                        <div class="col-17">
                            <h2>3. Du får en behandling - helt gratis</h2>
                            <p>Så snart köpet gått igenom får du en gratis behandling som tack. Använd länken flera gånger för att få fler behandlingar.</p>
                        </div>
                    </div>

            </div>

        </div>

    </div>
</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    components: {},

    data () {
        return {
            pageTitle: 'Värva en vän',
            url: '',

            fetcher: {
                autoFill: [
                    'url'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/referral'
        }
    },

    methods: {

        showShare()
        {

            if (navigator.share) {

                navigator.share({
                  text: "Tips! Har du friskvårdsbidrag kvar? Köp ett klippkort på massage hos Hälsoresurs.💚 Du förtjänar avkoppling. Och psst..jag får en massage när jag värvar dig.",
                  url: this.url
                }).then(() => {
                  console.log('Delat.');
                })
                .catch(console.error);

            }else{
                

            }

            this.matomoTrackEvent('Referral', 'Referral', 'Dela länken')
            
        },

    }
}
</script>
